import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    output,
} from '@angular/core';
import type { FilePreviewPanelConfig } from '../models';
import {
    PreviewPaneButtons,
    toPreviewPaneButtons,
} from './preview-pane-buttons';

@Component({
    selector: 'qpx-preview-panel-buttons',
    imports: [PreviewPaneButtons],
    templateUrl: './preview-panel-buttons.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'contents',
    },
})
export class PreviewPanelButtons {
    //#region Inputs
    public readonly panels = input<readonly FilePreviewPanelConfig[]>([]);
    public readonly activePanelId = input<string | null>(null);
    public readonly disabled = input(false);
    public readonly viewerReady = input(true);
    //#endregion

    //#region Outputs
    public readonly panelToggle = output<FilePreviewPanelConfig>();
    //#endregion

    protected readonly choices = computed(() =>
        toPreviewPaneButtons(
            this.panels(),
            this.activePanelId(),
            (panel) => this.panelToggle.emit(panel),
            this.disabled(),
            this.viewerReady()
        )
    );
}
